import * as req from 'api/actions';
import * as c from './constants';

export const inquire = (inquire_no, callback) => req.item(
  c.INQUIRE,
  `/v1/${inquire_no}`,
  {},
  callback,
);

export const validate = (inquire_no, params, callback) => req.item(
  c.VALIDATE,
  `/v1/${inquire_no}/inquire`,
  params,
  callback,
);

export const pay = (inquire_no, payload, callback) => req.create(
  c.PAY,
  `/v1/${inquire_no}`,
  payload,
  callback,
  {
    defaultMessage: false,
  },
);
